import styled from "styled-components";
import { Alert as RBAlert } from "antd";

export const StyledAlert = styled(RBAlert)`
.btn-close,
.btn-close:focus
{outline:none;box-shadow: none;}
&.ant-alert-info{
    --info-bg:#e6f4ff;
    --info-border:#91caff;
    background: var(--info-bg);
    border-color: var(--info-border);
}
`
